import { Box } from "@mui/material";
import type { FC } from "react";

/** One run of a search result: `match` runs are emphasized, the rest render plain. */
export type HighlightSegment = { text: string; match: boolean };

type Props = {
	segments: HighlightSegment[];
};

/**
 * Renders the matched run of a search result in the brand color (bold), the rest plain.
 * Color comes from `theme.palette.primary` — never a hardcoded hex. Generic: any search UI can pass segments.
 */
export const HighlightedText: FC<Props> = ({ segments }) => {
	let offset = 0;
	return (
		<>
			{segments.map((segment) => {
				// Stable key from the segment's char offset in the label (not the array index).
				const key = `${offset}-${segment.match}`;
				offset += segment.text.length;
				return segment.match ? (
					<Box key={key} component="mark" sx={(theme) => ({ backgroundColor: "transparent", color: theme.palette.primary.dark, fontWeight: 700, padding: 0 })}>
						{segment.text}
					</Box>
				) : (
					<span key={key}>{segment.text}</span>
				);
			})}
		</>
	);
};
